import { TableRow, TableCell } from '@mui/material';
import dateFormatter from '../../../formatters/dateFormatter';

import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// List item component for displaying individual visit records in a table
const VisitsListItem = props => {
  // Check if the visit status is "Finished"
  const statusFinished = props.status === "Finished";

  // Determine if download functionality should be enabled
  const isDownloadEnabled = statusFinished;

  // Function to map status keys to display labels in Spanish
  const getStatusLabel = (status) => {
    const statusMap = {
      'Scheduled': 'Programada',
      'Started': 'Iniciada',
      'Waiting for conclusion': 'Esperando conclusión',
      'Finished': 'Finalizada'
    };
    return statusMap[status] || 'Desconocido'; // Return 'Desconocido' for unknown statuses
  };

  return (
    <TableRow>
      {/* Candidate ID cell */}
      <TableCell>{props.candidateId}</TableCell>
      
      {/* Candidate name cell */}
      <TableCell>{props.candidateName}</TableCell>
      
      {/* Phone number cell */}
      <TableCell>{props.phone}</TableCell>
      
      {/* Formatted visit date cell */}
      <TableCell>{dateFormatter(props.dateVisit)}</TableCell>
      
      {/* Company name cell */}
      <TableCell>{props.companyName}</TableCell>
      
      {/* Status label cell (translated to Spanish) */}
      <TableCell>{getStatusLabel(props.status)}</TableCell>

      {/* Action cell with download button */}
      <TableCell align="center" sx={{ verticalAlign: 'middle' }}>
        <Tooltip title={isDownloadEnabled ? "Descargar informe" : "Informe no disponible"}>
          <span>
            <IconButton
              onClick={() => {
                if (isDownloadEnabled) {
                  // Call download handler with requirementId if download is enabled
                  props.onDownloadClick?.(props.requirementId);
                } else {
                  // Show warning dialog if download is not available
                  props.showDialog?.('Advertencia', 'Informe no disponible para esta visita.');
                }
              }}
              disabled={!isDownloadEnabled} // Disable button if download is not enabled
              sx={{
                color: isDownloadEnabled ? 'primary.main' : 'grey.400', // Color changes based on enabled state
              }}
            >
              <DownloadIcon /> {/* Download icon */}
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default VisitsListItem;